<template>
<div class="page-wrapper page"> <!-- v-bind:class="pages.slug" -->
    <div class="page-grid-wrapper standardPage">

        <div class="page-grid-fix">
            <article class="grid-container columns-one tick features-watches v-cloak">
                <section class="section1">
                    <MembersNavigation />
                </section>
    

                <section class="section2 regular-gap">
                        <div class="grid-view" v-if="searchedWatches.length">
                            <div v-for="watch in searchedWatches" :key="watch.SKU" class="grid-item watch__card " ref="card">

                            <!-- <div v-for="watch in watches" :key="watch.StockItemId" class="grid-item"> -->
                                <div class="watch__card-content">

                                    <!-- <router-link v-if="watch.ManufacturerName === 'Richard Mille'" :to="{ name: 'rmwatch', params: { watchSKU: watch.SKU, watchModel: watch.Model.split(' ').join('')  }}"> -->
                                        <!-- <router-link to="'RM-Watch/' . watch.StockItemId"> -->
                                        <figure>
                                        <img class="watch-image" :src="'/watches/gallery/NW-' + watch.SKU + '/grid-image/' + 'grid_NW-' + watch.SKU + '.jpg'" alt="" :key="watch.SKU">
                                        
                                            <figcaption>
                                                <span>{{ watch.Name }}</span>
                                                <!-- <h3>{{ watch.Name }}</h3>
                                                <span v-if="watch.StatusName === 'Sold'">Sold</span>
                                                <span class="price" v-else-if="watch.Price > 250000">POA</span>
                                                <span class="price" v-else ><span class="currancy">£</span>{{ watch.Price | formatNumber}}</span> <span class="grid-status-divider"> | </span> <span class="status">{{ watch.StatusName }}</span> -->
                                            </figcaption>
                                        </figure>
                                        <!-- <span class="grid-inquiry">Details</span> -->
                                    <!-- </router-link> -->
                                    
                                    <!-- <router-link v-else :to="{ name: 'otherwatch', params: { watchSKU: watch.SKU, watchModel: watch.Model.split(' ').join('')  }}"> -->
                                        <!-- <router-link to="'RM-Watch/' . watch.StockItemId"> -->
                                        <!-- <figure> -->
                                        <!-- <img class="watch-image" :src="'/watches/gallery/NW-' + watch.SKU + '/grid-image/' + 'grid_NW-' + watch.SKU + '.jpg'" alt="" :key="watch.SKU"> -->
                                        
                                            <!-- <figcaption> -->
                                                <!-- <span>Members exlusive</span> -->
                                                <!-- <h3>{{ watch.Name }}</h3>
                                                <span v-if="watch.StatusName === 'Sold'">Sold</span>
                                                <span class="price" v-else-if="watch.Price > 250000">POA</span>
                                                <span class="price" v-else ><span class="currancy">£</span>{{ watch.Price | formatNumber}}</span> <span class="grid-status-divider"> | </span> <span class="status">{{ watch.StatusName }}</span> -->

                                            <!-- </figcaption> -->
                                        <!-- </figure> -->
                                    <!--  <span class="grid-inquiry">Details</span> -->
                                    <!-- </router-link> -->
                                    
                                    
                <!-- 	                <span class="grid-inquiry" @click="ShowInquiry = watch.StockItemId ">Enquire</span>
                                    <form class="grid-inquiry-form" :class="{ show:ShowInquiry == watch.StockItemId }">
                                        <h2></h2>
                                        <EnquiryForm :Model="watch.Model" :SKU="watch.SKU" formType="New Arrivals Grid View Enquiry "></EnquiryForm>
                                        <div class="close" @click="ShowInquiry = 0 ">X</div>
                                    </form> -->
                                    
                                    
                                </div>
                            </div>           
                        </div>
                </section>
            </article>
       
        </div>
<!--         <div v-if="!searchedWatches.length && delayForm" class="no-search-results">
            <h2>Unfortunately we can’t find what you are looking for right now</h2>
            <p>Please Contact Us to Register Your Interest</p>
            <form>
                <ContactForm></ContactForm>                         
            </form>
        </div>   -->

    </div>
</div>
</template>


<script>
import { mapGetters } from "vuex";
import VuePagination from '../components/Pagination.vue';
// import EnquiryForm from '../components/EnquiryForm.vue';
import ContactForm from '../components//ContactForm.vue';
import MembersNavigation from "../components/MembersNavigation";

export default {
    name: 'MembershipFeaturedWatches',
    components: {
        VuePagination,
        // EnquiryForm,
        ContactForm,
        MembersNavigation
    },
    
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
        window.addEventListener('scroll', this.handleScroll);
        this.redirectByStatus();
       },
    
    watch: {
            '$route.name': function () {
              this.showRoute = this.$route.name;
            }
            
/*              $route(to, from) {
                this.reloadPage();
            }, */
          },
          
    data() {
        return {
            window: {
                width: 0
            },
           selectedBrand: 'Search by brands:', 
           images: {},
           watches: [],
           watch: [],
           search: "",
           searchhide: false,
           selected: undefined,
           ShowInquiry: undefined,
           showRoute: {
              showRoute : this.$route.name
          },
          searchText: '',
          delayForm: false
        };
    },
 
       
    computed: {
        ...mapGetters("auth", ["authUser"]),
        
        ifActive: function () {
            return {
                searchActive: this.search !== '' || this.selectedBrand !== 'Search by brands:' &&  this.selectedBrand !== 'All Brands'
            }
          },
          searchedWatches: function(){
              return this.watches.filter((watch) => {
                  if(this.selectedBrand == 'All Brands' || this.selectedBrand == '' || this.selectedBrand == 'Search by brands:') {
                      /* alert('All Brands'); */
                  return watch.Name.toLowerCase().match(this.search.toLowerCase()) || watch.ManufacturerName.toLowerCase().match(this.search.toLowerCase()) || watch.Description.toLowerCase().match(this.search.toLowerCase()) || watch.Model.split(' ').join('').toLowerCase().match(this.search.split(' ').join('').toLowerCase()) || watch.SKU.toLowerCase().match(this.search.toLowerCase());
                 
                  }
                  if(this.selectedBrand == watch.ManufacturerName) {
                  /* alert("this is " + this.selectedBrand); */
                  return watch.Name.toLowerCase().match(this.search.toLowerCase()) || watch.ManufacturerName.toLowerCase().match(this.search.toLowerCase()) || watch.Description.toLowerCase().match(this.search.toLowerCase()) || watch.Model.split(' ').join('').toLowerCase().match(this.search.split(' ').join('').toLowerCase()) || watch.SKU.toLowerCase().match(this.search.toLowerCase());
                  }
                  /* alert("nothing"); */
              });
          },    
        
        uniqueNames: function() {
            var Remove_duplicate_Value = [];
            for(var i =0; i < this.searchedWatches.length; i++) {
              if(Remove_duplicate_Value.indexOf(this.searchedWatches[i].ManufacturerName) == -1) {
                Remove_duplicate_Value.push(this.searchedWatches[i].ManufacturerName)
              }
            }
          return Remove_duplicate_Value;
          },

        classArray(){
            return {
                toggle : true,
                    'visible' : this.searchhide
            }
            
          },
    },
    
    mounted() {
        window.onresize = () => {
            this.windowWidth = window.innerWidth
        },
        /* this.importAll(require.context('watches/gallery/' + watch.SKU + '/grid-image/', true, /\.jpg$/)); */
        this.getWatchesOrderes();
        this.showRoute = this.$route.name;

        setTimeout(
                _ => this.delayForm = true, // render form
                2000 // after 2 second
              )
      },    
      
     methods: { 
         redirectByStatus () {
           if (this.authUser.status !== 1) {
               this.$router.push('/dashboard');
           }
         },
         handleResize() {
             this.window.width = window.innerWidth;
         },
         getWatchesOrderes(address) {
              this.$axios.get(address ? address : "/api/membershipwatches" ).then(response => {
                 console.log(response.data.data);
               this.watches = response.data.data;
               this.$emit("route-data-ready");
             });
           },
           searchtoggle: function() {
               this.searchhide = !this.searchhide;
               /* console.log(document.getElementById('#search-contaner')); */
             },
           handleScroll(event) {
               // Any code to be executed when the window is scrolled
               
               const element = this.$el.querySelector("#search-container");
               if (element !== null) {
                if (element.classList.contains("visible")) {
                    element.classList.remove("visible");
                    this.searchhide = !this.searchhide;
                }
               }
             },

      },
      
      destroyed () {
          window.removeEventListener('resize', this.handleResize);
          window.removeEventListener('scroll', this.handleScroll);
          
      },
      
};
</script>
